import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { CampaignAdHocList } from '../models/lists.model';

export const NameChanged = createAction(
  '[Create New List]: Name Changed',
  props<{ name: string }>(),
);

export const ListTypeChanged = createAction(
  '[Create New List]: List Type Changed',
  props<{ listType: string }>(),
);

export const TargetChanged = createAction(
  '[Create New List]: Target Changed',
  props<{ target: string }>(),
);

export const ListNotesChanged = createAction(
  '[Create New List]: List Notes Changed',
  props<{ listNotes: string }>(),
);

export const DropZoneEnabled = createAction('[Create New List]: Drop Zone Enabled');

export const DropZoneDisabled = createAction('[Create New List]: Drop Zone Disabled');

export const ButtonPointerEventEnabled = createAction(
  '[Create New List]: Button Pointer Event Enabled',
);

export const ButtonPointerEventDisabled = createAction(
  '[Create New List]: Button Pointer Event Disabled',
);

export const GetFile = createAction('[Create New List]: Get File', props<{ file: any }>());

export const RemoveFile = createAction('[Create New List]: Remove File');

export const FileNameChanged = createAction(
  '[Create New List]: File Name Changed',
  props<{ fileName: string }>(),
);

export const FileNotSupported = createAction('[Create New List]: File Not Supported');

export const UploadedFileChanged = createAction(
  '[Create New List]: Uploaded File Changed',
  props<{ name: string; size: number }>(),
);

export const FileToUploadChanged = createAction(
  '[Create New List]: File To Upload Changed',
  props<{ fileToUpload: any }>(),
);

export const FileReaderError = createAction('[Create New List]: File Reader Error');

export const EmailChanged = createAction(
  '[Create New List]: Email Changed',
  props<{ email: string }>(),
);

export const SubmitNewListData = createAction('[Create New List]: Submit New List Data');

export const CreateNewListWithFile = createAction(
  '[Create New List]: Create New List With File',
  props<{ hasEmail: boolean }>(),
);

export const CreateNewListWithFileSuccess = createAction(
  '[Create New List]: Create New List With File Success',
  props<{ res: any }>(),
);

export const CreateNewListWithFileFailed = createAction(
  '[Create New List]: Create New List With File Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CreateNewList = createAction('[Create New List]: Create New List');

export const CreateNewListSuccess = createAction(
  '[Create New List]: Create New List Success',
  props<{ res: CampaignAdHocList }>(),
);

export const CreateNewListFailed = createAction(
  '[Create New List]: Create New List Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const AttributeTypeChanged = createAction(
  '[Create New List]: Attribute Type Changed',
  props<{ attributeType: string }>(),
);

export const AttributeNameChanged = createAction(
  '[Create New List]: Attribute Name Changed',
  props<{ attributeName: string }>(),
);
